<template>
    <v-container>
        <v-card v-if="secureorgdata">
            <v-card-text v-if="secrets.stripe">
                Stripe Keys TEST
                <v-text-field
                        label="Stripe Test Public"
                        v-model="secrets.stripe.test.public"
                        clearable
                        outlined
                        hint="Required - Can be changed at any time"
                        @keyup="setChange()"
                ></v-text-field>
                <v-text-field
                        label="Stripe Test Secret"
                        v-model="secrets.stripe.test.secret"
                        clearable
                        outlined
                        hint="Required - Can be changed at any time"
                        @keyup="setChange()"
                ></v-text-field>
                <v-divider></v-divider>
                Stripe Live Keys
                <v-text-field
                        label="Stripe Live Public"
                        v-model="secrets.stripe.live.public"
                        clearable
                        outlined
                        hint="Required - Can be changed at any time"
                        @keyup="setChange()"
                ></v-text-field>
                <v-text-field
                        label="Stripe Live Secret"
                        v-model="secrets.stripe.live.secret"
                        clearable
                        outlined
                        hint="Required - Can be changed at any time"
                        @keyup="setChange()"
                ></v-text-field>
                <v-divider></v-divider>
                Paypal Keys
                <v-text-field
                        label="Client Secret (Live Mode)"
                        v-model="secrets.paypal.live.client_secret"
                        clearable
                        outlined
                        hint="Required - Can be changed at any time"
                        @keyup="setChange()"
                ></v-text-field>
                <v-text-field
                        label="Client Id (Live Mode)"
                        v-model="secrets.paypal.live.client_id"
                        clearable
                        outlined
                        hint="Required - Can be changed at any time"
                        @keyup="setChange()"
                ></v-text-field>
                <v-text-field
                        label="Paypal Account Email"
                        v-model="secrets.paypal.live.email"
                        clearable
                        outlined
                        hint="Required - must be on paypal account or sending invoices will not work"
                        @keyup="setChange()"
                ></v-text-field>
                <p>
                    Paypal -> My Apps and Credentials -> Live Webhooks
                    Webhook in Paypal App: https://api.18panels.com/api/event/capture
                    *Enable all events, for full live data
                </p>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="cancel()" :disabled="unchanged">
                    <v-icon>{{$store.state.icons.ban}}</v-icon>
                    <span class="hidden-xs-only">Cancel</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="saveSecure()" :color="!unchanged?'indigo':''" :disabled="unchanged" :loading="loading">
                    <span>Save</span>
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-skeleton-loader
                v-else
                class="mx-auto"
                type="card"
        ></v-skeleton-loader>
    </v-container>
</template>

<script>
  import {
    mapActions
  } from 'vuex'
  import isEqual from 'lodash/isEqual'
  import cloneDeep from 'lodash/cloneDeep'
  export default {
    components: {},
    name: "ReceivePayments",
    data() {
      return {
        secureorgdata: undefined,
        secrets: undefined,
        secrets_unchanged: undefined,
        unchanged:true,
        loading:false
      }
    },
    computed:{

    },
    mounted() {
      this.getsecure()
    },
    methods: {
      ...mapActions(['put','get']),
      cancel(){
        this.secrets = cloneDeep(this.secrets_unchanged)
        this.unchanged = true
      },
      async getsecure(){
        this.secureorgdata = await this.get({path:'api/orgs/json'})
        this.secrets = this.secureorgdata.secrets
        if (this.secrets.stripe) {
          this.secrets_unchanged = cloneDeep(this.secrets)
        } else {
          this.secrets = {
            "stripe":
                {
                  "test":
                      { "public": undefined,
                        "secret": undefined
                      },
                  "live": {
                    "public": undefined,
                    "secret": undefined
                  }
                },
            "paypal": {
              "sandbox": {
                "mode": "sandbox",
                "client_secret": undefined,
                "client_id": undefined,
                "email": undefined
              },
              "live": {
                "mode": "live",
                "client_secret": undefined,
                "client_id": undefined,
                "email": undefined
              }
            }
          }
        }
      },
      setChange(){
        let a = this.secrets
        let b = this.secrets_unchanged
        let s = isEqual(a,b)
        console.log(s)
        this.unchanged = s
      },
      async saveSecure(){
        this.loading =  true
        let f = await this.put({path:'api/orgs/secrets',body:this.secrets})
        this.loading=false
        window.location.reload()
      }
    }
  }
</script>

<style scoped>

</style>